@let o = offer();

<div [class]="'c-images u-m-top--md u-m-bottom--md c-images--' + (o.images.length + 1)">
	<div (click)="indexImageCarousel.set(0)" [style.background-image]="o.poster?.url ? 'url(' + o.poster?.url + ')' : 'none'">
		@if (o.poster?.youtubeUrl) {
			<p class="c-images__video c-images__video--lg">
				<tvcore-icon name="video"></tvcore-icon>
			</p>
		}
	</div>

	@for (img of o.images; track img.id) {
		<div (click)="indexImageCarousel.set($index + 1)" [style.background-image]="'url(' + img.url + ')'">
			@if ($index === 3) {
				<p class="c-images__see-more c-images__see-more--lg">
					<tvcore-icon name="images"></tvcore-icon>
					{{ 'DETAIL.MORE_IMAGES' | translate: { amount: o.images.length + 1 } }}
				</p>
			}

			@if (img.youtubeUrl) {
				<p class="c-images__video c-images__video--lg">
					<tvcore-icon name="video"></tvcore-icon>
				</p>
			}
		</div>
	}

	@if (o.images.length > 4) {
		<p class="c-images__see-more c-images__see-more--sm">
			<tvcore-icon name="images"></tvcore-icon>
			<br />
			{{ 'DETAIL.MORE_IMAGES' | translate: { amount: o.images.length + 1 } }}
		</p>
	}
</div>

@if (indexImageCarousel() !== null) {
	<ivva-image-carousel [(index)]="indexImageCarousel" [images]="allImages()"></ivva-image-carousel>
}
